import axios from "axios";

export const fetchAvailableClientAdmins = async (parentCompanyId?: string) => {
  const query = parentCompanyId ? `?parentCompanyId=${parentCompanyId}` : "";
  return await axios.get(`/api/parentcompany/available-client-admins${query}`);
};
